import { render, staticRenderFns } from "./AddOrUpdateUser.vue?vue&type=template&id=9f8c71bc&scoped=true&"
import script from "./AddOrUpdateUser.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateUser.vue?vue&type=script&lang=ts&"
import style0 from "./AddOrUpdateUser.vue?vue&type=style&index=0&id=9f8c71bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8c71bc",
  null
  
)

export default component.exports